/**
 * Product Ranking Display
 * 各商品カードの左上にランキング番号を表示する機能
 * カスタム設定に対応
 */

// 即時関数で囲んで重複宣言を防ぐ
(function() {
  'use strict';
  
  // 既に実行済みの場合はスキップ
  if (window.ProductRankingInitialized) {
    return;
  }
  window.ProductRankingInitialized = true;

  class ProductRanking {
    constructor() {
      this.init();
    }

    init() {
      // DOMが完全に読み込まれた後に実行
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.applyRanking());
      } else {
        this.applyRanking();
      }
    }

    applyRanking() {
      // data-product-ranking 属性を持つすべての商品リストアイテムを取得
      const productItems = document.querySelectorAll('.resource-list__item[data-product-ranking]');

      productItems.forEach((item) => {
        const ranking = item.getAttribute('data-product-ranking');
        if (!ranking) return;

        // card-gallery 要素を探す
        const cardGallery = item.querySelector('.card-gallery');
        if (!cardGallery) return;

        // 既にランキングラベルが存在する場合はスキップ
        if (cardGallery.querySelector('.ranking-label')) return;

        // セクションからカスタム設定を取得
        const section = item.closest('[data-ranking-settings]');
        let settings = null;
        if (section) {
          try {
            const settingsJson = section.getAttribute('data-ranking-settings');
            if (settingsJson) {
              settings = JSON.parse(settingsJson);
            }
          } catch (e) {
            console.warn('Failed to parse ranking settings:', e);
          }
        }

        // ランキングラベルを作成
        const rankingLabel = this.createRankingLabel(ranking, settings);

        // card-gallery の最初の子要素として挿入
        cardGallery.insertBefore(rankingLabel, cardGallery.firstChild);
      });
    }

    createRankingLabel(ranking, settings) {
      const label = document.createElement('div');
      const rankNum = parseInt(ranking, 10);

      // 基本クラスを設定
      label.className = 'ranking-label';
      label.setAttribute('aria-label', `ランキング ${ranking}位`);
      label.textContent = ranking;

      // カスタム設定がある場合は適用
      if (settings) {
        const rankKey = rankNum <= 3 ? `rank${rankNum}` : 'rank4plus';
        const rankSettings = settings[rankKey] || {};

        // インラインスタイルを明示的に適用
        const paddingValue = settings.padding || 8;
        
        label.style.position = 'absolute';
        label.style.top = '8px';
        label.style.left = '8px';
        label.style.zIndex = '10';
        label.style.display = 'inline-flex';
        label.style.alignItems = 'center';
        label.style.justifyContent = 'center';
        label.style.fontSize = `${settings.fontSize || 14}px`;
        label.style.fontFamily = settings.fontFamily || 'var(--font-body--family)';
        label.style.fontWeight = settings.fontWeight || '600';
        label.style.borderRadius = `${settings.borderRadius || 4}px`;
        // パディングを個別に指定
        label.style.paddingTop = `${paddingValue}px`;
        label.style.paddingRight = `${paddingValue}px`;
        label.style.paddingBottom = `${paddingValue}px`;
        label.style.paddingLeft = `${paddingValue}px`;
        label.style.border = rankSettings.borderWidth !== undefined
          ? `${rankSettings.borderWidth}px solid ${rankSettings.borderColor || 'transparent'}`
          : 'none';
        label.style.color = rankSettings.textColor || 'var(--color-foreground)';
        label.style.backgroundColor = rankSettings.bgColor || '#f5f5f5';
        label.style.boxSizing = 'border-box';
        label.style.lineHeight = '1';
      } else {
        // デフォルトスタイル（CSSクラスベース）
        let rankClass = 'default';
        if (rankNum === 1) rankClass = '1';
        else if (rankNum === 2) rankClass = '2';
        else if (rankNum === 3) rankClass = '3';

        label.className = `ranking-label ranking-label--${rankClass}`;
      }

      return label;
    }
  }

  // インスタンスを作成
  new ProductRanking();
})();

